"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateTotalTestsOptional = exports.useStateTotalTests = exports.useStateTotalMembers = exports.useStateTotalConferences = exports.useStateWeeklyTests = exports.useStateWeeklySummary = exports.useStateWeeklyMembers = exports.useStateWeeklyConferences = void 0;
const react_query_1 = require("react-query");
const account_1 = require("../../features/base/account");
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
const getStateRequestOptions = () => ({
    method: 'GET',
    headers: {
        Authorization: `Bearer ${getToken()}`,
    },
});
const buildStateUrl = (path, queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    return `/api/mimac/v1/class/${class_id}/state/${path}${queryString ? `?${queryString}` : ''}`;
};
const getStateWeeklyConferences = async (queryString) => {
    return (0, functions_1.fetchData)(buildStateUrl('conferences', queryString), getStateRequestOptions());
};
const getStateWeeklyMembers = async (queryString) => {
    return (0, functions_1.fetchData)(buildStateUrl('members', queryString), getStateRequestOptions());
};
const getStateWeeklySummary = async (queryString) => {
    return (0, functions_1.fetchData)(buildStateUrl('summary', queryString), getStateRequestOptions());
};
const getStateWeeklyTests = async (queryString) => {
    return (0, functions_1.fetchData)(buildStateUrl('tests', queryString), getStateRequestOptions());
};
const getStateTotalConferences = async () => {
    return (0, functions_1.fetchData)(buildStateUrl('total/conferences', ''), getStateRequestOptions());
};
const getStateTotalMembers = async () => {
    return (0, functions_1.fetchData)(buildStateUrl('total/members', ''), getStateRequestOptions());
};
const getStateTotalTests = async (queryString) => {
    return (0, functions_1.fetchData)(buildStateUrl('total/tests', queryString), getStateRequestOptions());
};
const getStateTotalTestsOptional = async (queryString) => {
    return (0, functions_1.fetchData)(buildStateUrl('total/tests/optional', queryString), getStateRequestOptions());
};
const useStateQuery = (key, getData) => {
    return (0, react_query_1.useQuery)(key, getData, {
        keepPreviousData: true,
        select: (data) => data.result,
        enabled: false,
        cacheTime: 300000,
        staleTime: 60000,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        retry: 0,
        suspense: false,
        useErrorBoundary: false,
        onError: (error) => {
            console.error(error);
        },
    });
};
const useStateWeeklyConferences = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data || {});
    return useStateQuery([`state_weekly_conferences_${queryString}`, data], () => getStateWeeklyConferences(queryString));
};
exports.useStateWeeklyConferences = useStateWeeklyConferences;
const useStateWeeklyMembers = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data || {});
    return useStateQuery([`state_weekly_members_${queryString}`, data], () => getStateWeeklyMembers(queryString));
};
exports.useStateWeeklyMembers = useStateWeeklyMembers;
const useStateWeeklySummary = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data || {});
    return useStateQuery([`state_weekly_summary_${queryString}`, data], () => getStateWeeklySummary(queryString));
};
exports.useStateWeeklySummary = useStateWeeklySummary;
const useStateWeeklyTests = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data || {});
    return useStateQuery([`state_weekly_tests_${queryString}`, data], () => getStateWeeklyTests(queryString));
};
exports.useStateWeeklyTests = useStateWeeklyTests;
const useStateTotalConferences = () => {
    return useStateQuery('state_total_conferences', () => getStateTotalConferences());
};
exports.useStateTotalConferences = useStateTotalConferences;
const useStateTotalMembers = () => {
    return useStateQuery('state_total_members', () => getStateTotalMembers());
};
exports.useStateTotalMembers = useStateTotalMembers;
const useStateTotalTests = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data || {});
    return useStateQuery([`state_total_tests_${queryString}`, data], () => getStateTotalTests(queryString));
};
exports.useStateTotalTests = useStateTotalTests;
const useStateTotalTestsOptional = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data || {});
    return useStateQuery([`state_total_tests_optional_${queryString}`, data], () => getStateTotalTestsOptional(queryString));
};
exports.useStateTotalTestsOptional = useStateTotalTestsOptional;
